var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("退货")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.showItemListDlg }
            },
            [_vm._v("选择商品")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.goodsRecvVoucher.goodsRecvVoucherItemList,
                border: "",
                "tooltip-effect": "dark"
              }
            },
            [
              _vm.showAssetInfo
                ? _c(
                    "el-table-column",
                    { attrs: { align: "center", label: "资产信息" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "devcName",
                          label: "名称",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "devcCatName",
                          label: "分类",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "devcBrandName",
                          label: "品牌",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "devcModel",
                          label: "型号",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "devcFixedSpec",
                          label: "规格",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAssetInfo
                ? _c(
                    "el-table-column",
                    { attrs: { align: "center", label: "商品信息" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "title",
                          label: "名称",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "catName",
                          label: "分类",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "brandName",
                          label: "品牌",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "model",
                          label: "型号",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "fixedSpec",
                          label: "规格",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAssetInfo
                ? _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "title",
                      label: "名称",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAssetInfo
                ? _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "120",
                      prop: "catName",
                      label: "分类",
                      "show-overflow-tooltip": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAssetInfo
                ? _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "100",
                      prop: "brandName",
                      label: "品牌",
                      "show-overflow-tooltip": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAssetInfo
                ? _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "130",
                      prop: "model",
                      label: "型号",
                      "show-overflow-tooltip": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAssetInfo
                ? _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "130",
                      prop: "fixedSpec",
                      label: "规格",
                      "show-overflow-tooltip": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "shipQuantity",
                  label: "已收货数量",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "exchgSumQuantity",
                  label: "已换货数量",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "assetCheckedQuantity",
                  label: "已验收数量",
                  width: "100",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "returnSumQuantity",
                  label: "已退货数量",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "returnQuantity",
                  label: "退货数量",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.assetType == 0
                          ? _c("el-input", {
                              staticClass: "text-right",
                              attrs: { type: "text", disabled: true },
                              on: {
                                change: function($event) {
                                  _vm.returnQuantityChange(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.returnQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "returnQuantity", $$v)
                                },
                                expression: "scope.row.returnQuantity"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.assetType == 1
                          ? _c("el-input", {
                              staticClass: "text-right",
                              attrs: {
                                type: "text",
                                disabled:
                                  scope.row.shipQuantity ==
                                  scope.row.returnSumQuantity +
                                    scope.row.exchgSumQuantity +
                                    scope.row.assetCheckedQuantity
                              },
                              on: {
                                change: function($event) {
                                  _vm.returnQuantityChange(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.returnQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "returnQuantity", $$v)
                                },
                                expression: "scope.row.returnQuantity"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.assetType == 3
                          ? _c("el-input", {
                              staticClass: "text-right",
                              attrs: {
                                type: "text",
                                disabled:
                                  scope.row.shipQuantity ==
                                  scope.row.returnSumQuantity +
                                    scope.row.exchgSumQuantity
                              },
                              on: {
                                change: function($event) {
                                  _vm.returnQuantityChange(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.returnQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "returnQuantity", $$v)
                                },
                                expression: "scope.row.returnQuantity"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "描述",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { type: "text" },
                          model: {
                            value: scope.row.desc,
                            callback: function($$v) {
                              _vm.$set(scope.row, "desc", $$v)
                            },
                            expression: "scope.row.desc"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "操作",
                  width: "140",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.assetType == 0
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.returnGoods(scope.row)
                                  }
                                }
                              },
                              [_vm._v("退货明细")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeGoods(scope.$index)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form", { attrs: { model: _vm.goodsRecvVoucher } }, [
        _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("退货原因")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "exceptional" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", clearable: true },
                        model: {
                          value: _vm.goodsRecvVoucher.returnCause,
                          callback: function($$v) {
                            _vm.$set(_vm.goodsRecvVoucher, "returnCause", $$v)
                          },
                          expression: "goodsRecvVoucher.returnCause"
                        }
                      },
                      _vm._l(_vm.goodsReturnCauseList, function(item) {
                        return _c("el-option", {
                          key: item.name,
                          attrs: { label: item.name, value: item.id }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("退货原因说明")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "dateStart" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.goodsRecvVoucher.returnDesc,
                        callback: function($$v) {
                          _vm.$set(_vm.goodsRecvVoucher, "returnDesc", $$v)
                        },
                        expression: "goodsRecvVoucher.returnDesc"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevContract }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.saveGoodsRecvVoucher()
              }
            }
          },
          [_vm._v("提交")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1049e556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1049e556","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsReturnVoucherSave.vue
// module id = 2951
// module chunks = 0